import React, { useContext, useRef } from "react";
import "./HomeBanner.css";
import ArrowDown from "../../Assets/Images/Arrowdown.svg";

import HomeOverlayElement1 from "../../Assets/Images/home-overlay-element-1.png";
import HomeOverlayElement2 from "../../Assets/Images/home-overlay-element-3.png";
import HomeOverlayElement3 from "../../Assets/Images/home-overlay-element-2.png";

import HomeOverlayMobileElement3 from "../../Assets/Images/home-overlay-element-mobile-2.png";
import HomeOverlayMobileElement2 from "../../Assets/Images/home-overlay-element-mobile-3.png";

import SliderSection from "../SliderSection";
import { LanguageContext } from "../../Hooks/langugaeContext";
import { TransEn, TransEs, TransPu } from "../../constants/HomeBannerConst";

function HomeBanner({ scrollCallBack }) {
  // language translation code
  const { language } = useContext(LanguageContext);
  // const translations = language === "Eng" ? TransEn : TransEs;
  let translations;
  if (language === "Eng") {
    translations = TransEn;
  } else if (language === "Es") {
    translations = TransEs;
  } else if (language === "Pu") {
    translations = TransPu;
  } else {
    translations = TransEn; // Default to English if language is unknown
  }

  // const scrollToRef = useRef(null);
  // const scrollToContent = () => {
  //   scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  // };
  return (
    <div>
      {/* Hero Section */}

      <section className="home-welcome page-banner-vs container-fluid">
        <div className="home-overlay-bg"></div>
        <div className="home-welcome-overlay-element">
          <div className="absolute w-full h-full animate__animated animate__fadeInDown">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one hidden lg:block"
              src={HomeOverlayElement2}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one block lg:hidden"
              src={HomeOverlayMobileElement2}
            />
          </div>
          <div className="absolute w-full h-full lg:z-[4] z-[6] animate__animated animate__fadeInDown">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two hidden lg:block"
              src={HomeOverlayElement3}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two block lg:hidden"
              src={HomeOverlayMobileElement3}
            />
          </div>
          <div className="absolute w-full h-full z-[4] animate__animated animate__fadeInUp">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--three "
              src={HomeOverlayElement1}
            />
          </div>
        </div>
        <div className="relative container z-[6] left-0 right-0">
          <div className="h-full flex items-center banner-content-vs max-w-[493px] md:pl-0 px-4">
            <div className="relative ">
              <h1 className="md:mb-4 mb-2 md:leading-[2.8rem] text-[1.25rem] leading-[1.5rem] md:text-[2.5rem] font-semibold tracking-tight  animated fadeInUp">
                {translations.title}
              </h1>
              <p className="mb-4 md:text-[1rem] text-[14px] leading-normal md:text-[16px] worldclstext animated fadeInUp">
                {translations.subTitle}
              </p>
              <div className="text-teal-900 py-2 md:pl-0 rounded-full text-lg mt-12 font-semibold lg:hidden block animated fadeInUp">
                <div className="flex space-x-3 text-white items-center">
                  <div
                    onClick={scrollCallBack} // Attach scroll handler
                    className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                  >
                    <img
                      src={ArrowDown}
                      alt="Scroll down arrow"
                      className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                    />
                  </div>
                  <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                    {translations.learnMore}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 bottom-16 lg:block hidden animated fadeInUp">
          <div className="text-teal-900 px-4 py-2 md:pl-0 rounded-full text-lg font-semibold">
            <div className="flex space-x-3 text-white items-center">
              <div
                onClick={scrollCallBack} // Attach scroll handler
                className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
              >
                <img
                  src={ArrowDown}
                  alt="Scroll down arrow"
                  className="logo animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                />
              </div>
              <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                {translations.learnMore}
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* New Section to Scroll To */}
      {/* <div ref={scrollToRef} className="animated fadeInUp my-8 mt-10 lg:mt-28">
        <SliderSection />
      </div> */}

      <div className="bg-[#0D4248] block md:hidden h-[80px] w-full relative -top-[1]"></div>
    </div>
  );
}

export default HomeBanner;
